import ScoreTennis from "./ScoreTennis";
export default ScoreTennis;
